import { ArrowRight, MapPin } from "lucide-react";
import { periodLabel, useProjects } from "./LavoriRealizzati";

const API = process.env.REACT_APP_BACKEND_URL;

// Nelle schede prodotto: i lavori pubblicati in cui il prodotto è stato installato. Vuoto se nessuno.
export const InstallatiDaNoi = ({ productKey }) => {
    const items = useProjects().filter((p) => (p.products || []).some((r) => r.key === productKey));
    if (!items.length) return null;
    return (
        <div className="mt-6" data-testid={`installati-da-noi-${productKey}`}>
            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#4F5D70]">Installati da noi</div>
            <ul className="mt-2.5 space-y-2">
                {items.map((p) => (
                    <li key={p.id}>
                        <a href={`/realizzazioni/${p.slug}`} data-testid={`installato-${p.slug}`} className="group flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 p-2 pr-3 transition-colors hover:border-[#E30613]/50 hover:bg-white">
                            <span className="h-14 w-16 shrink-0 overflow-hidden rounded-lg bg-slate-200">{p.cover && <img src={`${API}${p.cover}`} alt="" loading="lazy" className="h-full w-full object-cover" />}</span>
                            <span className="min-w-0 flex-1">
                                <span className="line-clamp-2 text-sm font-bold leading-snug text-[#0B1F3A]">{p.title}</span>
                                <span className="mt-0.5 flex items-center gap-1 text-xs text-[#4F5D70]"><MapPin className="h-3 w-3 text-[#E30613]" />{[p.city, p.province && `(${p.province})`].filter(Boolean).join(" ")}{p.period && ` · ${periodLabel(p.period)}`}</span>
                            </span>
                            <ArrowRight className="h-4 w-4 shrink-0 text-[#E30613] transition-transform group-hover:translate-x-1" />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};
